import * as React from "react";
// ui 
import { useStyletron } from 'baseui';
// features
import LeftMenuToolbar from '../LeftMenuToolbar/LeftMenuToolbar'
import { Footer } from '../Footer/Footer'
import { SideView } from '../SideView/SideView'
import { Grid, Cell, BEHAVIOR, STYLE } from 'baseui/layout-grid';
import useIsMobile from "../../hooks/useIsMobile/useIsMobile";
import { addAlpha } from "../../utils/colorUtils";
import { Outlet } from "react-router-dom";


export function PageLayout(props: any) {
  const [css, theme] = useStyletron();
  const isLarge = !useIsMobile();
  const defaultPadding = theme.sizing.scale500;

  const leftRightPadding = !isLarge ? '0px' : theme.sizing.scale500;

  const footerHeight = '60px';

  if (isLarge) {
    return (
      <Grid gridGaps={[16, 16, 16, 16]} behavior={BEHAVIOR.fluid}>
        <Cell span={[1, 1, 1]}>
          <div className={css({
            paddingTop: defaultPadding,
            paddingRight: leftRightPadding,
            borderRight: '1px solid ' + theme.colors.borderOpaque,
            height: '100%',
            justifyContent: 'space-between',

          })}>
            <div className={css({
              display: 'flex',
              flexDirection: 'column',
              position: 'sticky',
              top: defaultPadding,
              justifyContent: 'space-between',
              height: '90vh'
            })}>
              <LeftMenuToolbar></LeftMenuToolbar>
            </div>
          </div>
        </Cell>

        <Cell span={[9, 9, 9]}>
          <main className={css({
            paddingTop: defaultPadding,
            height: '100%',
            paddingBottom: 0
          })}     >
            <Outlet />
          </main>
        </Cell>

        <Cell span={[2, 2, 2]}>
          <aside
            className={css({
              padding: defaultPadding,
              borderLeft: '1px solid ' + theme.colors.borderOpaque,
              height: '100%',
            })}>
            <SideView />
          </aside>
        </Cell>
      </Grid>
    );
  }



  // small or tablet
  return (
    < >
      <div className={css({
        paddingTop: defaultPadding,
        paddingLeft: leftRightPadding,
        paddingRight: leftRightPadding,
      })}  >
        <Outlet />
        <div className={css({ opacity: 0.0 })}>
          <Footer  ></Footer>
        </div>
      </div>
      <div className={css({
        position: 'fixed',
        width: '100%',
        height: 'auto',
        bottom: 0,
        zIndex: 99999,
        background: addAlpha(theme.colors.backgroundPrimary, 0.8),
        borderTop: '1px solid ' + theme.colors.borderOpaque,
        backdropFilter: 'blur(6px)'
        //display: 'flex',
        //alignContent: 'center',
        //alignItems: 'center',
      })}>
        <Footer ></Footer>
      </div>
    </>
  );
}
